/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Nav_NotionInputs */

const en_mk_cmp_nav_notion = /** @type {(inputs: Mk_Cmp_Nav_NotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs Notion`)
};

const id_mk_cmp_nav_notion = /** @type {(inputs: Mk_Cmp_Nav_NotionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs Notion`)
};

/**
* | output |
* | --- |
* | "vs Notion" |
*
* @param {Mk_Cmp_Nav_NotionInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_nav_notion = /** @type {((inputs?: Mk_Cmp_Nav_NotionInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Nav_NotionInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_nav_notion(inputs)
	return en_mk_cmp_nav_notion(inputs)
});